import { Layout } from 'antd'
import { styled } from 'styled-components'

import { DeviceMediaQuery } from 'src/styles'
import { colors } from 'src/styles/theme'

const { Sider } = Layout

const NAVBAR_BG = colors.primary

export const StyledSider = styled(Sider)`
  background-color: ${NAVBAR_BG} !important;
  padding: 0;

  @media ${DeviceMediaQuery.TABLET} {
    position: fixed !important;
    height: calc(100vh - 56px) !important;
    z-index: 1500 !important;
    top: 56px;
  }

  @media (min-width: 901px) {
    position: relative !important;
    top: 0;
    height: 100vh !important;
    z-index: auto !important;
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .ant-layout-sider-zero-width-trigger {
    display: none !important;
  }
`

export const StyledNavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 72px 0 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const StyledBottomNavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 0 24px;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;

  a {
    padding: 20px 16px !important;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.06);
  }
`

export const StyledNavItem = styled.li<{ $active?: boolean }>`
  a {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px 32px;
    color: ${({ $active }) => ($active ? '#ffffff' : 'rgba(255, 255, 255, 0.8)')};
    text-decoration: none;
    font-size: 1rem;
    font-weight: ${({ $active }) => ($active ? 600 : 400)};
    transition:
      background-color 0.2s,
      color 0.2s;
    border-radius: 8px;
    margin: 0 24px;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      color: #ffffff;
    }

    &:focus-visible {
      outline: 2px solid #ffffff;
      outline-offset: -2px;
    }
  }
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  svg {
    width: 22px;
    height: auto;
  }
`

export const StyledMask = styled.div`
  display: none;
  width: 100vw;
  height: calc(100vh - 56px);
  position: fixed;
  top: 56px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 1400;

  @media ${DeviceMediaQuery.TABLET} {
    display: block;
  }

  @media (min-width: 901px) {
    display: none;
    top: 0;
    height: 100vh;
    position: absolute;
  }
`
